export enum EFiltryGlowneInAtrybutyMulti {
  Lokalizacje = 'Lokalizacje',
  Miasta = 'Miasta',
}
export enum EFiltryGlowneInAtrybutySingle {
  TerminWyjazdu = 'TerminWyjazdu',
  TypTransportu = 'TypTransportu',
}
